import getTodoRequestHeaders from './getTodoRequestHeaders';
import { format } from 'owa-strings';
import { GetTasksResponse, GetTasksServiceResponse } from './GetTasksServiceResponse';
import { makeGetRequest } from 'owa-ows-gateway';
import {
    TODO_API_GET_COMPLETED_TASKS_IN_FOLDER_FORMAT,
    TODO_API_DEFAULT_FOLDER,
} from './constants';

/**
 * Makes the Get tasks call to the server to get recently completed task items for the specified folder
 * or the default tasks folder if not specified.
 * @param {number} maxTaskToFetch maximum number of tasks to fetch
 * @param {string} folderId optional folder id of requested task folder
 * @returns promise of GetTasksServiceResponse
 */
export default function getRecentlyCompletedTasksService(
    maxTaskToFetch: number,
    folderId?: string
): Promise<GetTasksServiceResponse> {
    const folderIdToUse = folderId ? folderId : TODO_API_DEFAULT_FOLDER;
    const url = format(
        TODO_API_GET_COMPLETED_TASKS_IN_FOLDER_FORMAT,
        folderIdToUse,
        maxTaskToFetch
    );

    return makeGetRequest(
        url,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then(async (response: Response) => {
            const responseBody = <GetTasksResponse>await response.json();
            return {
                StatusCode: response.status,
                ResponseBody: responseBody,
            };
        })
        .catch(err => {
            return null;
        });
}
